import {wdiCore} from '@/components/WdiControls';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {Col, Row} from 'antd';
import {responseResultError, responseResultOk} from '@/utils/response';
import {useEffect} from 'react';

export const ColumnType = {
  // 临界金额
  MinValue1: 1,
  // 临界数量
  MinValue2: 2,
  // 临界比例
  MinValue3: 3,
  // 返利比例
  StandardValue1: 4,
  // 单件费用
  StandardValue2: 5,
};

export const RevenueGroupType = {
  None: 0,
  Revenue: 1,
  Quantity: 2,
  convert: (revenueType?: number) => {
    if (revenueType && ((151 <= revenueType && revenueType < 200) || (251 <= revenueType && revenueType < 300))) {
      return RevenueGroupType.Revenue;
    }
    if (revenueType && ((101 <= revenueType && revenueType < 150) || (201 <= revenueType && revenueType < 250))) {
      return RevenueGroupType.Quantity;
    }
    return RevenueGroupType.None;
  }
}

type SCTRateGridHeaderProps = {};
const headerStyle: React.CSSProperties = {
  textAlign: 'left',
  height: '35px',
  lineHeight: '35px',
  paddingLeft: '2px',
  border: '1px solid #DDDDDD',
};
const SCTRateGridHeader: React.FC<SCTRateGridHeaderProps> = (props: SCTRateGridHeaderProps) => {
  return (
    <Row>
      <Col span={8} style={headerStyle}>
        临界金额
      </Col>
      <Col span={8} style={headerStyle}>
        临界比例(%)
      </Col>
      <Col span={8} style={headerStyle}>
        结案比例
      </Col>
    </Row>
  );
};

type SCTRateGridRowValue = {
  minValue1?: number;
  minValue2?: number;
  minValue3?: number;
  standardValue1?: number;
  standardValue2?: number;
};

type SCTRateGridRowProps = {
  rowIndex: number;
  revenueGroupType: number;
  readonly?: boolean;
  criticalType?: number;
  standardType?: number;
  value?: SCTRateGridRowValue;
  onChange: (columnType: number, rowIndex: number, v: number | undefined) => void;
};

const rowStyle: React.CSSProperties = {
  textAlign: 'left',
  height: '35px',
  lineHeight: '35px',
  paddingLeft: '1px',
};

const match = (target: number, source?: number) => {
  if (source === undefined || source === null || source === 0) {
    return true;
  }
  if (target === source) {
    return true;
  }
  return false;
};

const isNullOrEmpty = (value: any) => {
  if (value === null || value === undefined) {
    return true;
  }
  if (value === '') {
    return true;
  }
  return false;
};

const SCTRateGridRow: React.FC<SCTRateGridRowProps> = (props: SCTRateGridRowProps) => {
  return (
    <Row>
      <Col span={8} style={rowStyle}>
        <WdiInputNumber
          readOnly={!!props.readonly || !match(RevenueGroupType.Revenue, props.revenueGroupType) || !match(ColumnType.MinValue1, props.criticalType)}
          min={0}
          value={props.value?.minValue1}
          onChange={(value: any) => {
            if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
              props.onChange(
                ColumnType.MinValue1,
                props.rowIndex,
                wdiCore.Number.ToNumber(value, 2),
              );
            } else {
              props.onChange(ColumnType.MinValue1, props.rowIndex, undefined);
            }
          }}
        />
      </Col>
      {/*<Col span={5} style={rowStyle}>
        <WdiInputNumber
          readOnly={!!props.readonly || !match(RevenueGroupType.Quantity, props.revenueGroupType) || !match(ColumnType.MinValue2, props.criticalType)}
          min={0}
          value={props.value?.minValue2}
          onChange={
            (value: any) => {
              if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
                props.onChange(ColumnType.MinValue2, props.rowIndex, wdiCore.Number.ToNumber(value, 2));
              } else {
                props.onChange(ColumnType.MinValue2, props.rowIndex, undefined);
              }
            }
          }
        />
      </Col>*/}
      <Col span={8} style={rowStyle}>
        <WdiInputNumber
          readOnly={!!props.readonly || !match(RevenueGroupType.Revenue, props.revenueGroupType) || !match(ColumnType.MinValue3, props.criticalType)}
          format="p"
          digits={4}
          min={0}
          value={props.value?.minValue3}
          onChange={(value: any) => {
            if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
              props.onChange(
                ColumnType.MinValue3,
                props.rowIndex,
                wdiCore.Number.ToNumber(value, 6),
              );
            } else {
              props.onChange(ColumnType.MinValue3, props.rowIndex, undefined);
            }
          }}
        />
      </Col>
      <Col span={8} style={rowStyle}>
        <WdiInputNumber
          readOnly={!!props.readonly || !match(RevenueGroupType.Revenue, props.revenueGroupType) || !match(ColumnType.StandardValue1, props.standardType)}
          format="p"
          digits={4}
          min={0}
          value={props.value?.standardValue1}
          onChange={(value: any) => {
            if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
              props.onChange(
                ColumnType.StandardValue1,
                props.rowIndex,
                wdiCore.Number.ToNumber(value, 6),
              );
            } else {
              props.onChange(ColumnType.StandardValue1, props.rowIndex, undefined);
            }
          }}
        />
      </Col>
      {/*<Col span={4} style={rowStyle}>
        <WdiInputNumber
          readOnly={!!props.readonly || !match(RevenueGroupType.Quantity, props.revenueGroupType) || !match(ColumnType.StandardValue2, props.standardType)}
          min={0}
          value={props.value?.standardValue2}
          onChange={
            (value: any) => {
              if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
                props.onChange(ColumnType.StandardValue2, props.rowIndex, wdiCore.Number.ToNumber(value, 2));
              } else {
                props.onChange(ColumnType.StandardValue2, props.rowIndex, undefined);
              }
            }
          }
        />
      </Col>*/}
    </Row>
  );
};

type SCTRateGridValue = {
  criticalType?: number;
  standardType?: number;
  items: SCTRateGridRowValue[];
};

type SCTRateGridProps = {
  revenueGroupType: number;
  readonly?: boolean;
  value?: SCTRateGridValue;
  onChange?: (value?: SCTRateGridValue) => void;
};

const SCTRateGrid: React.FC<SCTRateGridProps> = (props: SCTRateGridProps) => {

  const onValueChange = (columnType: number, rowIndex: number, v: number | undefined) => {
    const value: SCTRateGridValue = {
      standardType: props.value?.standardType,
      criticalType: props.value?.criticalType,
      items: [],
    };
    let criticalType = 0, standardType = 0;
    props.value?.items?.forEach((item, itemIndex) => {
      let result = item;
      if (itemIndex === rowIndex) {
        if (columnType == ColumnType.MinValue1) {
          result.minValue1 = v;
        } else if (columnType == ColumnType.MinValue2) {
          result.minValue2 = v
        } else if (columnType == ColumnType.MinValue3) {
          result.minValue3 = v;
        }
        if (columnType == ColumnType.StandardValue1) {
          result.standardValue1 = v;
        } else if (columnType == ColumnType.StandardValue2) {
          result.standardValue2 = v
        }
      }
      const rateGridValue = rateGridTypeValue(result);
      if (criticalType === 0) {
        criticalType = rateGridValue.criticalType;
      }
      if (standardType === 0) {
        standardType = rateGridValue.standardType;
      }
      value.items.push(result);
    });
    value.criticalType = criticalType;
    value.standardType = standardType;
    props.onChange?.(value);
  };

  useEffect(() => {
    if (props.revenueGroupType !== RevenueGroupType.None) {
      const items: any[] = []
      let criticalType = 0, standardType = 0;
      props?.value?.items?.map((item) => {
        let newItem: any = item;
        if (props.revenueGroupType === RevenueGroupType.Revenue) {
          newItem = {
            minValue1: item.minValue1,
            minValue3: item.minValue3,
            standardValue1: item.standardValue1,
          };
        } else if (props.revenueGroupType === RevenueGroupType.Quantity) {
          newItem = {
            minValue2: item.minValue2,
            standardValue2: item.standardValue2,
          };
        }
        items.push(newItem);
        const rateGridValue = rateGridTypeValue(newItem);
        if (criticalType === 0) {
          criticalType = rateGridValue.criticalType;
        }
        if (standardType === 0) {
          standardType = rateGridValue.standardType;
        }
      });

      props?.onChange?.({
        criticalType: criticalType,
        standardType: standardType,
        items: items
      });
    }
  }, [props.revenueGroupType]);

  return (
    <>
      <SCTRateGridHeader/>
      {props?.value?.items?.map((item, itemIndex) => (
        <SCTRateGridRow
          key={itemIndex}
          rowIndex={itemIndex}
          readonly={props.readonly}
          revenueGroupType={props.revenueGroupType}
          criticalType={props.value?.criticalType}
          standardType={props.value?.standardType}
          value={item}
          onChange={onValueChange}
        />
      ))}
    </>
  );
};

const res = {
  rowNumberP1: (rowNumber: number) => {
    return '第' + rowNumber + '行，';
  },
  revenueTypeIsNull: "无效的核算类型",
  revenueTypeCriticalNotMatch: "随量核算类型必须选择临界销量，随额核算类型必须选择临界金额/临界比例",
  revenueTypeResultNotMatch: "随量核算类型必须选择单箱费用，随额核算类型必须选择结案比例",
  expenseResultIsNull: "无效的费用标准",
  //criticalMust0: '临界值必须为0',
  criticalOnly1: '临界金额/临界比例必填且只能填1个',
  resultOnly1: '结案比例/单位费用只能填写1个',
  rebateRateMust0_1: '结案比例必须在0～1之间',
  unitFeeMustGt0: '单位费用必须为正数',
  criticalMustNumber: '临界值必须为数字',
  currentMustGtLast: '临界值必须大于上一行的临界值',
};

const rateGridTypeValue = (row: SCTRateGridRowValue) => {
  let criticalType = 0, standardType = 0;
  if (!isNullOrEmpty(row.minValue1)) {
    criticalType = ColumnType.MinValue1;
  }
  if (!isNullOrEmpty(row.minValue2)) {
    criticalType = ColumnType.MinValue2;
  }
  if (!isNullOrEmpty(row.minValue3)) {
    criticalType = ColumnType.MinValue3;
  }
  if (!isNullOrEmpty(row.standardValue1)) {
    standardType = ColumnType.StandardValue1;
  }
  if (!isNullOrEmpty(row.standardValue2)) {
    standardType = ColumnType.StandardValue2;
  }
  return {
    criticalType: criticalType,
    standardType: standardType,
  };
};

const jsonParse = (content: string) => {
  if (content === undefined || content === null || content === "") {
    return [];
  }
  return JSON.parse(content);
}

const initSalesContractRateGrid = (termsContent: string, rateType: number, revenueGroupType: number) => {
  const rows: SCTRateGridRowValue[] = [];
  let criticalType = rateType,
    standardType = 0;
  if (revenueGroupType === RevenueGroupType.Revenue) {
    standardType = ColumnType.StandardValue1;
  } else if (revenueGroupType === RevenueGroupType.Quantity) {
    standardType = ColumnType.StandardValue2;
  }
  const values: ExpenseResultItem[] = jsonParse(termsContent);
  if (values) {
    values.forEach((item) => {
      const row: SCTRateGridRowValue = {};
      if (criticalType == ColumnType.MinValue1) {
        row.minValue1 = item.value;
      } else if (criticalType == ColumnType.MinValue2) {
        row.minValue2 = item.value;
      } else if (criticalType == ColumnType.MinValue3) {
        row.minValue3 = item.value;
      }
      if (standardType == ColumnType.StandardValue1) {
        row.standardValue1 = item.standardValue;
      } else if (standardType == ColumnType.StandardValue2) {
        row.standardValue2 = item.standardValue;
      }
      rows.push(row);
    });
  }
  // 返利标准必须是5行
  for (let i = rows.length; i < 10; i++) {
    rows.push({});
  }
  return {
    criticalType,
    standardType,
    items: rows,
  };
};

type ExpenseResultItem = {
  value: number;
  standardValue: number;
};

type ExpenseResult = {
  items: ExpenseResultItem[];
  termsContent?: string;
  rateType: number;
};

const convertToResult = (rateGridValue?: SCTRateGridValue, revenueType?: number) => {
  const expenseResult: ExpenseResult = {
    items: [],
    rateType: 0
  };
  if (rateGridValue?.items && rateGridValue?.items?.length) {
    let currentRow = rateGridValue.items[0];
    let currentValue: any = {};
    let criticalType = 0,
      standardType = 0;

    if (!isNullOrEmpty(currentRow.minValue1)) {
      criticalType = ColumnType.MinValue1;
      currentValue.value = currentRow.minValue1;
    }
    if (!isNullOrEmpty(currentRow.minValue2)) {
      if (criticalType != 0) {
        return responseResultError(res.rowNumberP1(1) + res.criticalOnly1);
      }
      criticalType = ColumnType.MinValue2;
      currentValue.value = currentRow.minValue2;
    }
    if (!isNullOrEmpty(currentRow.minValue3)) {
      if (criticalType != 0) {
        return responseResultError(res.rowNumberP1(1) + res.criticalOnly1);
      }
      criticalType = ColumnType.MinValue3;
      currentValue.value = currentRow.minValue3;
    }
    if (criticalType == 0) {
      return responseResultError(res.rowNumberP1(1) + res.criticalOnly1);
    }

    if (!isNullOrEmpty(currentRow.standardValue1)) {
      standardType = ColumnType.StandardValue1;
      if (currentRow.standardValue1 < 0 || 1 < currentRow.standardValue1) {
        return responseResultError(res.rowNumberP1(1) + res.rebateRateMust0_1);
      }
      currentValue.standardValue = currentRow.standardValue1;
    }
    if (!isNullOrEmpty(currentRow.standardValue2)) {
      if (standardType != 0) {
        return responseResultError(res.rowNumberP1(1) + res.resultOnly1);
      }
      standardType = ColumnType.StandardValue2;
      if (currentRow.standardValue2 < 0) {
        return responseResultError(res.rowNumberP1(1) + res.unitFeeMustGt0);
      }
      currentValue.standardValue = currentRow.standardValue2;
    }
    if (standardType == 0) {
      return responseResultError(res.rowNumberP1(1) + res.rebateRateMust0_1);
    }

    expenseResult.items.push(currentValue);

    let lastValue = currentValue;
    for (let i = 1; i < rateGridValue.items.length; i++) {
      currentRow = rateGridValue.items[i];
      currentValue = {};

      if (standardType === ColumnType.StandardValue1) {
        if (isNullOrEmpty(currentRow.standardValue1)) {
          break;
        }
        if (currentRow.standardValue1 < 0 || 1 < currentRow.standardValue1) {
          return responseResultError(res.rowNumberP1(i + 1) + res.rebateRateMust0_1);
        }
        currentValue.standardValue = currentRow.standardValue1;
      }

      if (standardType === ColumnType.StandardValue2) {
        if (isNullOrEmpty(currentRow.standardValue2)) {
          break;
        }
        if (currentRow.standardValue2 < 0) {
          return responseResultError(res.rowNumberP1(i + 1) + res.unitFeeMustGt0);
        }
        currentValue.standardValue = currentRow.standardValue2;
      }

      if (criticalType === ColumnType.MinValue1) {
        if (isNullOrEmpty(currentRow.minValue1)) {
          return responseResultError(res.rowNumberP1(i + 1) + res.criticalMustNumber);
        }
        currentValue.value = currentRow.minValue1;
      }

      if (criticalType === ColumnType.MinValue2) {
        if (isNullOrEmpty(currentRow.minValue2)) {
          return responseResultError(res.rowNumberP1(i + 1) + res.criticalMustNumber)
        }
        currentValue.value = currentRow.minValue2;
      }

      if (criticalType === ColumnType.MinValue3) {
        if (isNullOrEmpty(currentRow.minValue3)) {
          return responseResultError(res.rowNumberP1(i + 1) + res.criticalMustNumber);
        }
        currentValue.value = currentRow.minValue3;
      }

      if (lastValue.value >= currentValue.value) {
        return responseResultError(res.rowNumberP1(i + 1) + res.currentMustGtLast);
      }
      expenseResult.items.push(currentValue);
      lastValue = currentValue;
    }

    const revenueGroupType = RevenueGroupType.convert(revenueType);
    if (revenueGroupType === RevenueGroupType.Revenue && !(criticalType === ColumnType.MinValue1 || criticalType === ColumnType.MinValue3)) {
      return responseResultError(res.revenueTypeCriticalNotMatch);
    }
    if (revenueGroupType === RevenueGroupType.Quantity && !(criticalType === ColumnType.MinValue2)) {
      return responseResultError(res.revenueTypeCriticalNotMatch);
    }
    if (revenueGroupType === RevenueGroupType.Revenue && !(standardType === ColumnType.StandardValue1)) {
      return responseResultError(res.revenueTypeResultNotMatch);
    }
    if (revenueGroupType === RevenueGroupType.Quantity && !(standardType === ColumnType.StandardValue2)) {
      return responseResultError(res.revenueTypeResultNotMatch);
    }
    expenseResult.rateType = criticalType;
    expenseResult.termsContent = JSON.stringify(expenseResult.items);
  } else {
    return responseResultError(res.expenseResultIsNull);
  }
  return responseResultOk(expenseResult);
};

export {convertToResult, initSalesContractRateGrid, SCTRateGrid};
